<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :append-to-body="true"
    title="选择用户"
    width="60%"
    @close="handleClose"
  >
    <div style="padding: 10px;">
      <data-table
        ref="pagingTable"
        :options="options"
        :list-query="listQuery"
        @select-changed="handleSelected"
      >
        <template #filter-content>
          <!-- <dic-list-select v-model="listQuery.params.state" dic-code="user_state" class="filter-item" style="width: 150px; margin-bottom: 0px"/> -->
          <depart-tree-select
            v-model="listQuery.params.deptCode"
            class="filter-item"
            style="width: 200px;"
            placeholder="请选择部门"
          />
          <el-input
            v-model="listQuery.params.labelNum"
            size="small"
            style="width: 200px;"
            placeholder="账号/姓名"
            class="filter-item"
            clearable
          />
          <el-button
            type="primary"
            class="filter-item"
            size="small"
            @click="handleConfirm"
            >{{ selectedLabel }}</el-button
          >
        </template>

        <template #data-columns>
          <el-table-column
            fixed
            width="100"
            label="姓名"
            align="center"
            prop="label"
          />

          <el-table-column
            width="120"
            label="账号"
            align="center"
            prop="account"
          />

          <el-table-column
            width="180"
            label="所属部门"
            align="center"
            prop="branchName"
            show-overflow-tooltip
          />
          <el-table-column label="岗位名称" align="center" prop="postName"  width="180" />

          <el-table-column
            width="100"
            label="岗位编码"
            align="center"
            prop="postCode"
          />
          <el-table-column
            width="180"
            label="岗位详情1"
            align="center"
            prop="postInfoFirst"
            show-overflow-tooltip
          />
          <el-table-column
            width="180"
            label="岗位详情2"
            align="center"
            prop="postInfoSecond"
            show-overflow-tooltip
          />
          <el-table-column
            width="180"
            label="岗位详情3"
            align="center"
            prop="postInfoThird"
            show-overflow-tooltip
          />

          <!-- <el-table-column
            label="邮箱"
            align="center"
            prop="email"
          /> -->
          <!-- <el-table-column
            label="状态"
            align="center"
            prop="state_dictText"
          /> -->
        </template>
      </data-table>
    </div>
  </el-dialog>
</template>

<script>
import { postAction } from "@/api";
export default {
  name: "UserSelectDialog",
  props: {
    excludes: Array,
    excludeDeparts: Array,
    excludeGroups: Array,
    dialogShow: {
      type: Boolean,
      default: false
    },
    selections: Array
  },
  data() {
    return {
      dialogVisible: false,
      selectedLabel: "请勾选用户",
      listQuery: {
        current: 1,
        size: 10,
        params: {
          state: "0",
          excludes: [],
          excludeDeparts: [],
          excludeGroups: []
        }
      },
      // 选定的数据列表
      selectedList: [],
      selectedObjs: [],
      options: {
        // 可批量操作
        multi: true,
        multiShow: false,
        keyId: "id",
        // 列表请求URL
        // listUrl: '/api/learn/api/sys/user/paging'
        listUrl: "/org/findUserByLabelAndNum"
      }
    };
  },

  watch: {
    // 检测查询变化
    dialogShow: {
      handler() {
        this.dialogVisible = this.dialogShow;
        
        if (this.$refs.pagingTable) {
          this.$refs.pagingTable.getList();
        }
      },
      deep: true
    },

    excludes: {
      handler() {
        this.listQuery.params.excludes = this.excludes;
        if (this.$refs.pagingTable) {
          this.$refs.pagingTable.getList();
        }
      },
      deep: true
    },
    excludeDeparts: {
      handler() {
        this.listQuery.params.excludeDeparts = this.excludeDeparts;
        if (this.$refs.pagingTable) {
          this.$refs.pagingTable.getList();
        }
      },
      deep: true
    },
    excludeGroups: {
      handler() {
        this.listQuery.params.excludeGroups = this.excludeGroups;
        if (this.$refs.pagingTable) {
          this.$refs.pagingTable.getList();
        }
      },
      deep: true
    },
    selectedList: {
      handler(val) {
        this.selectedLabel = "确认" + val.length + "项";
      }
    }
  },

  created() {
    this.dialogVisible = this.dialogShow;
    this.listQuery.params.excludes = this.excludes;
    this.listQuery.params.excludeDeparts = this.excludeDeparts;
    this.listQuery.params.excludeGroups = this.excludeGroups;
  },

  methods: {
    /////////////////

    // 选定回调
    handleSelected(data) {
      if (data) {
        this.selectedList = data.ids;
        this.selectedObjs = data.objs;
      }
    },

    // 关闭选择框
    handleClose() {
      
      this.$emit("update:dialogShow", false);
      this.$refs.pagingTable.clearSelection();
      this.selectedList = [];
      this.selectedObjs = [];

      this.listQuery.params.deptCode = ''
      this.listQuery.params.labelNum = ''
    },

    handleConfirm() {
      if (this.selectedList === null || this.selectedList.length === 0) {
        this.$message({
          type: "error",
          message: "请至少勾选一个用户！!"
        });
        return;
      }

      this.$emit("select", this.selectedList, this.selectedObjs);

      // 关闭
      this.handleClose();
    }
  }
};
</script>

<style scoped>
::v-deep .el-dialog__body {
  padding: 0px;
}
</style>
